// icons
import {
  ShareIcon,
  ArrowRightIcon,
  DeliveryExpressIcon,
} from "../../kits/Icons/Icons";

// styles
import "./ShopInfo.scss";
import colorSchema from "../../../assets/kits/colors/colors.module.scss";
import { addCommas } from "@persian-tools/persian-tools";
import defaultCoverShop from "../../../assets/images/defaultCover/defaultCoverShop.jpg";
import whitebg from "../../../assets/images/defaultCover/defaultCoverProduct.png";

// helper
import { pathMaker } from "../../../utilities/helperFunctions";
import React, { useState } from "react";
import BoxSlider from "../../common/slider/BoxSlider";

import { useAnalyticsEventTracker } from "../../../utilities/helperFunctions";
export default function ShopInfo({ ShopInfoData, situationShopFunc, banner }) {
  console.log("object", ShopInfoData);
  const [loadImg, setLoadImg] = useState(true);
  const [loadImgLogo, setLoadImgLogo] = useState(true);
  // const EventTracker = useAnalyticsEventTracker(
  //   "test cat",
  //   "test act",
  //   "test label"
  // );
  return (
    <div className="shop-info">
      <div className="cover-section">
        {ShopInfoData?.cover_file.length != 0 ? (
          <>
            {loadImg && <img className="w-100 " src={defaultCoverShop} />}
            <img
              className={`w-100 ${loadImg ? "d-none" : "d-block"}`}
              src={pathMaker(ShopInfoData?.cover_file?.path)}
              onLoad={() => setLoadImg(false)}
            />
          </>
        ) : (
          <img className="w-100 " src={defaultCoverShop} />
        )}

        <div className="d-flex justify-content-between icons pd-x-20">
          <div
            onClick={() => window.history.back()}
            style={{ cursor: "pointer" }}
          >
            <ArrowRightIcon color={colorSchema.foreground_background_he} />
          </div>
        </div>
      </div>
      <div className="pd-x-20 ">
        {banner && (
          <div className="mr-b-12 pd-x-20">
            <BoxSlider banner={banner} />
          </div>
        )}

        <div className="shop-detail mr-t-16 d-flex justify-content-between">
          <div>
            <div className="title-h3-b">{ShopInfoData?.supplier[0]?.title}</div>
            <div className="d-flex mr-t-6 situation">
              {situationShopFunc(
                ShopInfoData?.supplier[0]?.start_hour,
                ShopInfoData?.supplier[0]?.start_min,
                ShopInfoData?.supplier[0]?.finish_hour,
                ShopInfoData?.supplier[0]?.finish_min,
                ShopInfoData?.supplier[0]?.main_status
              )}

              <div
                className="desc-l d-flex pd-x-4 pd-t-2 delivery"
                // onClick={() => {
                //   console.log(" test&*");
                //   EventTracker();
                // }}
              >
                <DeliveryExpressIcon
                  width="16px"
                  height="16px"
                  color={colorSchema.foreground_background_he}
                />
                <span
                  className="mr-r-6"
                  style={{ color: colorSchema.foreground_background_he }}
                >
                  {ShopInfoData?.supplier[0]?.send_in_cost == "0"
                    ? "رایگان"
                    : `${addCommas(
                        ShopInfoData?.supplier[0]?.send_in_cost
                      )} تومان`}
                </span>
              </div>
            </div>
          </div>

          {ShopInfoData?.logo_file?.path != null ? (
            <>
              {loadImgLogo && (
                <img
                  className="logo"
                  style={{ borderRadius: 6 }}
                  src={whitebg}
                />
              )}
              <img
                className={`logo ${loadImgLogo ? "d-none" : "d-block"}`}
                style={{ borderRadius: 6 }}
                src={pathMaker(ShopInfoData?.logo_file?.path)}
                onLoad={() => setLoadImgLogo(false)}
              />
            </>
          ) : (
            <img
              className="logo"
              style={{ borderRadius: 6 }}
              src={whitebg}
              onLoad={() => setLoadImgLogo(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
